import { render } from "./Planning.vue?vue&type=template&id=163927fb"
import script from "./Planning.vue?vue&type=script&lang=js"
export * from "./Planning.vue?vue&type=script&lang=js"

import "./Planning.vue?vue&type=style&index=0&id=163927fb&lang=css"

import exportComponent from "/builds/aksoftware/software/haushaltsbuchfrontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__